// removed by extract-text-webpack-plugin
module.exports = {"deleteItem":"_-src-components-EditSplitButton-styles---deleteItem---1HFvo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EditSplitButton/styles.css
// module id = 828
// module chunks = 0